{
  "request": {
    "formExamples": {
      "itemName": "مثال: ورق A4 معاد تدويره",
      "unit": "مثال: صندوق",
      "businessReason": "مثال: توفير الورق للطباعة في منطقة الاستقبال.",
      "specification": "مثال: ورق A4 معاد تدويره، 80 غرامًا للمتر المربع، 500 ورقة في العبوة."
    },
    "draftRequest": "مسودة طلب شراء",
    "resumeDraft": "استئناف المسودة",
    "cartWithCurrency": "السلة · {{currency}}",
    "draftNumberNote": "يُعطى رقم الطلب عند تقديمه.",
    "returnedOn": "أُعيد في {{date}}",
    "returnedBy": "أعاده {{name}}",
    "returnedByOn": "أعاده {{name}} في {{date}}",
    "quantityNotSaved": "لم تُحفظ الكمية الجديدة",
    "lineNotRemoved": "لم يُحذف البند",
    "detailsNotSaved": "لم يُحفظ تعديلك على تفاصيل الطلب",
    "resubmitFailed": "لم يُعَد إرسال الطلب",
    "reorderFailed": "لم تتم إعادة الطلب",
    "cancelConsequence": "يوقف الإلغاء هذا الطلب نهائياً، ولا يمكن إعادة فتحه. يُغلق أي اعتماد ما زال بانتظار القرار، ويُحرَّر أي مبلغ يحجزه الطلب من الميزانية.",
    "keepRequest": "الإبقاء على الطلب",
    "onlyRequesterAmends": "يمكن لمقدم الطلب وحده تعديل هذا الطلب",
    "onlyRequesterChangesDraft": "يمكن لمقدم الطلب وحده تغيير مسودة الطلب هذه",
    "atLastSubmission": "عند آخر إرسال، {{date}}",
    "asLastSubmitted": "الأسعار والإجماليات كما كانت عند آخر إرسال ({{date}}). قد تكون البنود تغيّرت منذ ذلك الحين، وتُسعَّر من جديد عند إعادة إرسال الطلب.",
    "currentNotResubmitted": "بحسب الوضع الحالي، ولم تتم إعادة إرسال الطلب بعد",
    "lineBlocked": "لا يمكن طلبه بوضعه الحالي",
    "belowMinimum": "الحد الأدنى للطلب {{minimum}}. زد الكمية إلى {{minimum}} أو أكثر.",
    "belowMinimumNoFigure": "الكمية أقل من الحد الأدنى للطلب لهذا الصنف. زدها للمتابعة.",
    "returnedPricesNext": "تُؤكَّد أسعار البنود التي أضفتها أو غيّرتها عند فحص الطلب. عدّل الطلب لتراها ثم أعد إرساله.",
    "notPricedYet": "لم يُسعَّر بعد",
    "draftPricesNext": "تُؤكَّد الأسعار عند فحص المسودة. استأنف المسودة لتراها وترسلها.",
    "cartPricesNext": "تُؤكَّد الأسعار عند فحص السلة. استأنف المسودة لتراها وترسل الطلب.",
    "cancelConsequenceProcessing": "يوقف الإلغاء هذا الطلب نهائيًا، ولا يمكن إعادة فتحه. تُسحب الاتفاقية الإطارية التي أنشأتها ترسيته ما دامت مسودة، ولا يمكن تفعيلها بعد ذلك؛ ولا تتغيّر اتفاقية مفعّلة بالفعل. ويُحرَّر أي مبلغ من الموازنة يحجزه الطلب.",
    "cancelReasonRequired": "اذكر سبب إلغاء هذا الطلب.",
    "returnToSourcing": "إعادة إلى التوريد",
    "returnToSourcingTitle": "إعادة هذا الاحتياج إلى التوريد؟",
    "returnToSourcingConsequence": "تُسحب الترسية، ولا يمكن تفعيل الاتفاقية المسودة التي أنشأتها بعد ذلك. يعود الاحتياج إلى مرحلة التوريد، حيث يمكن إنشاء طلب عروض أسعار جديد له برقم خاص به. لا يُحذف شيء: يبقى طلب العروض السابق وترسيته والاتفاقية في السجل. أمّا الاتفاقية المفعّلة بالفعل فيجب إنهاؤها أولًا وفق دورة حياتها.",
    "returnToSourcingReasonRequired": "اذكر سبب إعادة الاحتياج إلى التوريد.",
    "keepWithProcurement": "إبقاؤه لدى المشتريات",
    "priceFromAgreement": "التسعير من الاتفاقية",
    "priceFromAgreementTitle": "تسعير هذا الطلب من اتفاقيته؟",
    "priceFromAgreementConsequence": "يُسعَّر الطلب نفسه من بند اتفاقيته المفعّلة، وتُحجز ميزانيته بهذا السعر، ويُجرى أي اعتماد تطلبه السياسة مرة واحدة على هذا الطلب. لا يُصدر أي أمر شراء بعد.",
    "priceAndReserve": "التسعير والحجز",
    "notNow": "ليس الآن",
    "orderingTitle": "تقدّم إصدار أوامر الشراء",
    "orderingSubtitle": "يُسجَّل الطلب على أنه مطلوب بعد إصدار كل أوامر الشراء المطلوبة من الموردين.",
    "orderingComplete": "صدرت جميع أوامر الشراء المطلوبة.",
    "orderingIssued": "الأوامر الصادرة",
    "orderingRemaining": "ما بقي طلبه",
    "orderingNoOrderYet": "لا يوجد أمر بعد",
    "orderingLastFailure": "تعذّرت المحاولة الأخيرة: {{message}}",
    "orderingInternalHanded": "سُلّمت البنود التي تُورَّد من المستودع إلى التنفيذ الداخلي.",
    "orderingBlocker": {
      "unsourced": "لم يُحدَّد مورد لهذا البند.",
      "supplier_not_procurable": "لا يمكن الشراء من المورد حاليًا.",
      "no_order": "لم يُنشأ له أمر شراء بعد.",
      "issue_failed": "تعذّر إصدار أمر الشراء الخاص به.",
      "order_draft": "لا يزال أمر الشراء الخاص به مسودة."
    }
  }
}
